var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap-evidencia", attrs: { show: _vm.show } },
    [
      _c("div", { staticClass: "modalEnvio", attrs: { id: "myModal2" } }, [
        _c("div", { staticClass: "modalEnvio-content" }, [
          _c(
            "div",
            [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass: "buttonClose buttonCloseEvidencia",
                  attrs: { align: "right" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: { click: _vm.handleCloseReport }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("close")
                      ]),
                      _vm._v("  \n            "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Cerrar")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                _c("div", { staticClass: "text-sm-center" }, [
                  _c("p", { staticStyle: { "margin-top": "40px" } }, [
                    _vm._v(_vm._s(_vm.text))
                  ])
                ]),
                _c("div", { staticClass: "text-sm-center" }, [
                  _c(
                    "p",
                    { staticStyle: { "margin-top": "40px" } },
                    [
                      _vm._v(
                        "\n              Puede ver sus reportes en el menú\n              "
                      ),
                      _c(
                        "router-link",
                        {
                          staticStyle: {
                            cursor: "pointer",
                            "font-size": "13px"
                          },
                          attrs: {
                            "active-class": "router-link-active",
                            to: "/conecta-reportes"
                          }
                        },
                        [_vm._v("Informes")]
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }